<div>
  <div class="position-relative py-3 px-4 text-center">
    <div class="flag">RS.100000</div>
    <div class="font-size-70 pt-3 pb-w text-gray-4">
      <i class="fe fe-star"></i>
    </div>
    <h5 class="font-size-24 font-weight-bold mb-1">1L PLAN</h5>
    <div class="font-size-18 text-uppercase mb-3">XXXX-XXXX-XXXX-XXXX</div>
    <div class="font-weight-bold font-size-18 text-uppercase mb-4">MASTER</div>
    <!-- <div class="border-top pt-3 font-italic">Expires at 03/22</div> -->
  </div>
</div>
